import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

export default new Router({
  mode: "history",
  routes: [
    {
      path: "*",
      name: "index",
      meta: {
        divHelper: "g-doc g-home",
        title: "首页",
      },
      component: () => import("./HomeIndex.vue"),
    },
    {
      path: "/login",
      name: "login",
      redirect: "/",
      meta: {
        divHelper: "g-doc",
        // needLogin: true,
        title: "登录",
      },
      component: () => import("./Login.vue"),
    },
    {
      path: "/getPass",
      name: "getPass",
      redirect: "/",
      meta: {
        divHelper: "g-doc",
        // needLogin: true,
        title: "找回密码",
      },
      component: () => import("./getPass.vue"),
    },
    {
      path: "/about",
      name: "about",
      meta: {
        divHelper: "g-doc",
        // needLogin: true,
        title: "关于",
      },
      component: () => import("./About.vue"),
    },
    {
      path: "/loginMooc",
      name: "loginMooc",
      redirect: "/",
      meta: {
        divHelper: "g-doc g-hidden",
        // needLogin: true,

        title: "正在登录",
      },
      component: () => import("./loginMooc.vue"),
    },
    {
      path: "/childIndex",
      name: "childIndex",
      meta: {
        divHelper: "g-doc ",
        // needLogin: true,

        title: localStorage.getItem("pathKey")
          ? localStorage.getItem("pathKey") == 2
            ? "高等本科"
            : localStorage.getItem("pathKey") == 3
            ? "职业教育"
            : ""
          : "",
      },
      // props: route => ({
      //   p: Number(route.query.p) || undefined,
      //   s: Number(route.query.s) || undefined,
      //   d: Number(route.query.d) || undefined
      // }),
      component: () => import("./childIndex.vue"),
    },
    {
      path: "/myIndex",
      name: "myIndex",
      meta: {
        divHelper: "g-doc",
        // needLogin: true,
        title: "个人中心",
      },
      component: () => import("./my.vue"),
    },
    {
      path: "/usIndex",
      name: "usIndex",
      meta: {
        divHelper: "g-doc",
        // needLogin: true,
        title: "关于我们",
      },
      component: () => import("./usMsg.vue"),
    },
    {
      path: "/ruralPromote",
      name: "ruralPromote",
      meta: {
        divHelper: "g-doc",
        // needLogin: true,
        title: "乡村振兴",
      },
      component: () => import("./ruralPromote.vue"),
    },
    {
      path: "/ruralList",
      name: "ruralList",
      meta: {
        divHelper: "g-doc",
        // needLogin: true,
        title: "乡村振兴",
      },
      component: () => import("./rural.vue"),
    },
    {
      path: "/ruralIndex",
      name: "ruralIndex",
      meta: {
        divHelper: "g-doc",
        // needLogin: true,
        title: "乡村振兴",
      },
      component: () => import("./ruralIndex.vue"),
    },
  ],
});
